export default "__VITE_ASSET__DAqVxvR2__"